/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  CLEAR_EXPENSE_LIST(state){
    state.expenseList=[]
  },
  SET_EXPENSE_LIST (state, val) {
    state.expenseList = val
  },
  UPDATE_EXPENSE_LIST (state, val) {
    state.expenseList.push(...val)
  },
  UPDATE_EXPENSE (state, expense) {
    const i = state.expenseList.findIndex(i => i.ExpenseId == expense.ExpenseId)
    Object.assign(state.expenseList[i], expense)
  },
  //Expense Dashboard
  SET_VENDOR_LIST(state, val) {
    state.vendors = val
  },
  //Expense General
  
}
